import { render, staticRenderFns } from "./requestServiceList.vue?vue&type=template&id=3bd01898&scoped=true"
import script from "./requestServiceList.vue?vue&type=script&lang=js"
export * from "./requestServiceList.vue?vue&type=script&lang=js"
import style0 from "./requestServiceList.vue?vue&type=style&index=0&id=3bd01898&prod&lang=css"
import style1 from "./requestServiceList.vue?vue&type=style&index=1&id=3bd01898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd01898",
  null
  
)

export default component.exports